export default __webpack_public_path__ + "static/media/aurora.16e610c9.svg";